import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setAccessToken } from "../utils/api"; // ⬅️ 바뀐 api 모듈
import "../css/Login.css";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("아이디와 비밀번호를 입력하세요.");
      return;
    }

    setLoading(true);
    try {
  const res = await api.post("/login", { username, password }, { withCredentials: true });
  const { accessToken } = res.data || {};
  if (!accessToken) throw new Error("토큰이 응답에 없습니다.");

  localStorage.setItem("accessToken", accessToken);
  setAccessToken(accessToken);
  navigate("/");
} catch (e) {
  const errData   = e?.response?.data;
  const status    = e?.response?.status;
  const statusTxt = e?.response?.statusText;

  // 서버 응답 형태에 맞춰 안전하게 문자열 생성
  const msg =
    typeof errData === "string" ? errData :
    errData?.message ||
    errData?.error ||
    (status ? `HTTP ${status} ${statusTxt || ""}`.trim() : e.message) ||
    "로그인 실패";

  setError("아이디 또는 비밀번호를 확인해주세요.");   // ✅ 문자열만 저장
} finally {
  setLoading(false);
}
  }

  return (
    <div className="login-container">
      <div className="Logo-container">DMSYSTEM ENGENIERING</div>
      <div className="login-box">
        <div className="login-form-container">
          <h1>로그인</h1>
          <form onSubmit={handleSubmit}>
            <input type="text" value={username} onChange={(e)=>setUsername(e.target.value)} placeholder="아이디" />
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="비밀번호" />
            <button type="submit" disabled={loading} className="login-btn">
              {loading ? "로그인 중..." : "로그인"}
            </button>
            <button type="button" onClick={() => navigate("/signup")} className="signup-btn">
              회원가입
            </button>
          </form>
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
    </div>
  );
}
